import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

const styles = theme => ({});
const required = value => (value ? undefined : 'Povinné');
const number = value => (value && isNaN(Number(value)) ? 'Musí být číslo' : undefined);

const enhance = compose(
  withStyles(styles),
  withRouter,
  withHandlers({}),
  reduxForm({ form: 'addCategoryForm' }),
);

export default enhance(({ classes, handleSubmit, setAddUser, setEdit, edit, history }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <Grid container spacing={24}>
      <Grid item xs={12}>
        <Field name="name" component={TextField} label="Název" validate={[required]} />
      </Grid>
      <Grid item xs={12}>
        <Field name="price" component={TextField} label="Cena" validate={[number, required]} />
      </Grid>
      <Grid item xs={12}>
        <Field name="description" component={TextField} label="Popis" />
      </Grid>
    </Grid>
    <div style={{ margin: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.submit}>
        Uložit
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          history.push('/services');
        }}
      >
        Zrušit
      </Button>
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/services/form/addForm.js